'use strict';

class OpeningHours {

    constructor() {

        let tables = document.querySelectorAll('[data-open-hours-table]');

        if (tables.length > 0) {

            let date = new Date();
            let currentDay = date.getDay();

            for (let i = 0; i < tables.length; i++) {

                let days = tables[i].querySelectorAll('[data-day-of-week]');
                let openHoursTodayHolder = tables[i].querySelector('[data-open-hours-today]');
                let remainingDay = false;

                if (days.length > 0) {

                    for (let i = 0; i < days.length; i++) {

                        let dayId = parseInt(days[i].dataset.dayOfWeek);

                        if (currentDay === dayId) {

                            days[i].classList.add('today', 'delay-1');
                            remainingDay = true;

                            if (openHoursTodayHolder) {

                                openHoursTodayHolder.innerHTML = days[i].dataset.overviewText;
                            }
                        }

                        if (remainingDay && currentDay !== dayId) {
                            let delayClass = `delay-${i - currentDay + 2}`;

                            days[i].classList.add('remaining', delayClass);
                        }
                    }
                }
            }
        }
    }
}

module.exports = OpeningHours;
